import {
  POLARITY_DEFAULT_COLORS,
  POLARITY_LABELS,
  type EvaluationPolarity,
  type EvaluationPolarityCounts,
} from '@citizen-walk/shared-types';

/**
 * 地点群の評価内訳 (ポジ / ネガ / 中立) の 1 行サマリ (docs/27 §9)。評価軸が無い (null) なら何も出さない。
 */
export function EvaluationSummaryLine({
  summary,
  polarityLabels = POLARITY_LABELS,
}: {
  summary: EvaluationPolarityCounts | null;
  /** 評価の区分の表示名 (評価の定義の `polarityLabels`)。 */
  polarityLabels?: Record<EvaluationPolarity, string>;
}) {
  if (!summary) return null;
  const total = summary.positive + summary.negative + summary.neutral;
  const pct = (n: number) => (total > 0 ? ` (${Math.round((n / total) * 100)}%)` : '');
  return (
    <p className="mb-2 text-xs text-slate-600 flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="font-medium text-slate-700">{summary.label}の内訳:</span>
      <span style={{ color: POLARITY_DEFAULT_COLORS.positive }}>
        {polarityLabels.positive} {summary.positive}
        {pct(summary.positive)}
      </span>
      <span style={{ color: POLARITY_DEFAULT_COLORS.negative }}>
        {polarityLabels.negative} {summary.negative}
        {pct(summary.negative)}
      </span>
      <span style={{ color: POLARITY_DEFAULT_COLORS.neutral }}>
        {polarityLabels.neutral} {summary.neutral}
        {pct(summary.neutral)}
      </span>
      {total === 0 && <span className="text-slate-400">評価付きの検出要素はありません</span>}
    </p>
  );
}
